<template>
  <div class="live_data">
    <div class="cell_box">
      <div class="plate_title" style="border-left: 1px solid #ebeced">
        <div class="plate_title_name">在线用户数量统计折线图</div>
      </div>
      <div class="condition_cell">
        <div class="fz14">日期：</div>
        <el-date-picker
          @change="getChatRoomStatistics3"
          style="width: 150px"
          v-model="date3"
          size="middle"
          type="date"
          placeholder="请选择日期"
          value-format="YYYY-MM-DD"
          :clearable="false"
        />
      </div>
      <div id="echarts_line3"></div>
    </div>

    <div class="cell_box">
      <div class="plate_title" style="border-right: 1px solid #ebeced">
        <div class="plate_title_name">在线用户列表({{ userList.length }})</div>
      </div>
      <div v-loading="loading4" class="user_cells overflow_y" id="userList">
        <div class="user_cell" v-for="(item, index) in userList" :key="index">
          <img class="user_avatar" :src="item.avatar" alt="" />

          <div>
            <div class="flex ai_c">
              <div>{{ item.nickname }}</div>
              <img
                v-if="item.moneyLevelImage"
                class="identity_level"
                :src="item.moneyLevelImage"
                alt=""
              />
              <img
                v-if="item.levelImage"
                class="identity_level"
                :src="item.levelImage"
                alt=""
              />
            </div>
            <div class="fz12">加入时间：{{ item.join_time }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import request from "@/utils/request";
export default {
  props: {
    circle_id: {
      type: Number,
      default: Number,
    },
  },
  data() {
    return {
      userList: [],
      date3: "",
      timer: null,
      loading3: false,
      loading4: false,
    };
  },
  computed: {
    placeholder() {
      return this.question ? "快来向老师提问吧~" : "快来参与圈友互动吧~";
    },
  },
  unmounted() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    this.getChatRoomStatistics3();
    this.getOnLineChatRoomList();
    this.timer = setInterval(() => {
      this.getChatRoomStatistics3();
      this.getOnLineChatRoomList();
    }, 1000 * 30);
  },
  methods: {
    async getOnLineChatRoomList() {
      this.loading4 = true;
      const res = await request.post(
        "/teacher/circle/getOnLineChatCricleList",
        {
          circle_id: this.circle_id,
        }
      );
      this.userList = res.data;
      setTimeout(() => {
        this.loading4 = false;
      }, 100);
      this.scoll4();
    },
    scoll4() {
      $("#userList").animate(
        {
          scrollTop: "99999px",
        },
        1000
      );
    },
    async getChatRoomStatistics3() {
      const res = await request.post("/teacher/circle/getChatRoomStatistics", {
        date: this.date3,
        circle_id: this.circle_id,
      });
      this.echartsLine3(res.data);
    },
    echartsLine3(data) {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.getElementById("echarts_line3"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "",
          left: "0",
          textStyle: {
            color: "#1A1A1A",
            fontSize: 16,
          },
        },
        tooltip: {
          confine: true,
          trigger: "axis",
          backgroundColor: "rgba(0,0,0,0.6)",
          textStyle: {
            color: "#fff",
          },
          axisPointer: {
            type: "cross",
          },
          // formatter(params) {
          //   // console.log('params', params)
          //   let str = `${params[0].name}<br />`;
          //   for (const item of params) {
          //     const data = item.data;
          //     if (data) {
          //       let dataVal = null;
          //       let marker = "";
          //       switch (item.seriesIndex) {
          //         case 0:
          //           marker = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;box-sizing: border-box;border: 1px solid ${"#F00000"};background-color:${"#F00000"};"></span>`;
          //           dataVal = data;
          //           break;
          //         case 1:
          //           marker = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;box-sizing: border-box;border: 1px dashed ${"#12C05E"};background-color:${"#12C05E"};"></span>`;
          //           dataVal = data;
          //           break;
          //         case 2:
          //           marker = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;box-sizing: border-box;border: 1px dashed ${"#5D45E7"};background-color:${"#5D45E7"};"></span>`;
          //           dataVal = data;
          //           break;
          //       }
          //       str += `${marker + item.seriesName}：${dataVal}<br />`;
          //     }
          //   }
          //   return str;
          // },
        },
        // legend: {
        //   data: ["PC", "安卓", "IOS"],
        //   top: 0,
        //   x: "center",
        // },
        grid: {
          top: 50,
          left: 70,
          right: 20,
          bottom: 30,
        },
        // 目前数据统计图表的时间范围为60天，取30天
        // dataZoom: [
        //   {
        //     type: "inside",
        //     start: 0,
        //     end: 100,
        //   },
        //   {
        //     show: true,
        //     type: "slider",
        //     bottom: "10px",
        //     start: 0,
        //     end: 100,
        //   },
        // ],
        xAxis: {
          type: "category",
          boundaryGap: true,
          // data: [
          //   "2022-07-04",
          //   "2022-07-05",
          //   "2022-07-06",
          //   "2022-07-07",
          //   "2022-07-08",
          // ],
          data: data.dataX,
          scale: true, // 是否是脱离 0 值比例。设置成 true 后坐标刻度不会强制包含零刻度
          axisLine: {
            // x轴
            show: true,
          },
          axisTick: {
            // x轴刻度线
            show: false,
          },
          axisLabel: {
            color: "#707070",
            fontSize: 10,
          },
        },
        yAxis: [
          {
            type: "value",
            name: "人",
            scale: true, // 是否是脱离 0 值比例。设置成 true 后坐标刻度不会强制包含零刻度
            nameLocation: "end",
            nameTextStyle: {
              color: "#1A1A1A",
              fontSize: 14,
              align: "right",
            },
            axisLine: {
              // y轴线
              show: false,
            },
            axisTick: {
              // y轴刻度
              show: false,
            },
            axisLabel: {
              // show :false,
              color: "#707070",
            },
            splitLine: {
              lineStyle: {
                color: "#ECECEC",
                width: 1,
                type: "solid",
              },
            },
          },
        ],
        series: [
          {
            color: "#F00000",
            name: "在线人数",
            type: "line",
            smooth: true,
            // data: [3814, 3757, 2067, 2028, 2091],
            data: data.dataY,
            showSymbol: true, // 拐点tooltip hover时候才显示出来
          },
          // {
          //   color: "#12C05E",
          //   name: "安卓",
          //   type: "line",
          //   smooth: true,
          //   data: [3714, 3657, 1967, 1928, 1991],
          //   showSymbol: true, // 拐点tooltip hover时候才显示出来
          // },
          // {
          //   color: "#5D45E7",
          //   name: "IOS",
          //   type: "line",
          //   smooth: true,
          //   data: [3614, 3557, 1867, 1828, 1891],
          //   showSymbol: true, // 拐点tooltip hover时候才显示出来
          // },
        ],
      });
    },
  },
};
</script>

<style scoped>
.live_data {
  display: flex;
  height: 600px;
}
.cell_box {
  width: 50%;
  height: 100%;
  box-sizing: border-box;
}

.cell_box:nth-child(1) {
  border-right: 1px solid #ebeced;
  /* border-bottom: 1px solid #ebeced; */
}

.cell_box:nth-child(2) {
  /* border-bottom: 1px solid #ebeced; */
}

.cell_box:nth-child(3) {
  border-right: 1px solid #ebeced;
}

.cell_box:nth-child(4) {
}

.plate_title {
  background-color: #f8fcff;
  font-size: 16px;
  font-weight: 500;
  box-sizing: border-box;
  /* padding: 18px 0; */
  border-top: 1px solid #ebeced;
  border-bottom: 1px solid #ebeced;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  padding-right: 25px;
}

.plate_title_name {
  position: relative;
  line-height: 16px;
  padding-left: 30px;
}

.plate_title_name::before {
  content: "";
  position: absolute;
  left: 13px;
  width: 4px;
  height: 16px;
  background-color: #5389f5;
  border-radius: 5px;
}
.condition_cell {
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
}
/deep/.el-input-number--large {
  width: 112px;
}

/deep/.el-divider--horizontal {
  width: 30px;
  margin: 0 8px;
}

.chat_box {
  width: 100%;
  height: calc(100% - 54px);
}

.scoll {
  line-height: 16px;
  margin-right: 30px;
  cursor: pointer;
}

/* ********************************** */
.chat_body {
  box-sizing: border-box;
  padding: 15px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.chat_body::-webkit-scrollbar {
  display: block;
  width: 4px;
  /*height: 6px;*/
}

.chat_body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px #aaa;
  background: rgba(0, 0, 0, 0.6);
}

.chat_body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px #aaa;
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.cell {
  margin-bottom: 20px;
}

.head {
  display: flex;
  align-items: center;
}

.avatar {
  width: 36px;
  height: 36px;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid #e7e7e7;
  box-sizing: border-box;
  margin-right: 10px;
}

.nickname {
  font-size: 14px;
  color: #4571e7;
  max-width: 130px;
}

.identity_level {
  height: 18px;
  display: block;
  margin-left: 6px;
}

.time {
  font-size: 12px;
  color: #8590a6;
}

.content {
  box-sizing: border-box;
  padding: 5px 0 0 40px;
}

.content >>> img {
  width: 200px;
}

#elementID {
  position: fixed;
  right: 50px;
  bottom: 50px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  color: #fff;
  cursor: pointer;
}

.tourist_cells {
  width: 100%;
  height: calc(100% - 54px);
  box-sizing: border-box;
  border-left: 1px solid #ebeced;
}

.tourist_cell {
  box-sizing: border-box;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}

.user_cells {
  width: 100%;
  height: calc(100% - 54px);
  box-sizing: border-box;
  border-left: 1px solid #ebeced;
}

.user_cell {
  box-sizing: border-box;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.user_avatar {
  width: 36px;
  height: 36px;
  display: block;
  margin-right: 4px;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid #e7e7e7;
  box-sizing: border-box;
}

.condition_cell {
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
}

#echarts_line1,
#echarts_line3 {
  width: 100%;
  height: calc(100% - 54px - 54px);
}

.userinfo_popup_member {
  width: 100%;
  display: flex;
  box-sizing: border-box;
  padding: 20px 10px 17px 20px;
  background: linear-gradient(225deg, #e3eeff 0%, #f3f8ff 100%);
}

.userinfo_popup_member .userinfo_avatar {
  width: 44px;
  height: 44px;
  object-fit: cover;
  flex-shrink: 0;
  display: block;
  border-radius: 50%;
  border: 1px solid #dedede;
}

.userinfo_popup_member .infos {
}

.userinfo_popup_member .infos .userinfo_nickname {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  word-break: break-all;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  max-width: 120px;
}

.userinfo_popup_member .infos .identity {
  margin-top: 4px;
  display: flex;
  align-items: center;
  column-gap: 8px;
}

.userinfo_popup_member .infos .identity_img {
  height: 29px;
  display: block;
}

.userinfo_popup_member .expiration_time {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  margin-top: 8px;
}
</style>
